import {
  Box,
  Text,
  Flex,
  Heading,
  Badge,
  SimpleGrid,
  IconButton,
  Tooltip,
  useDisclosure,
  Avatar,
} from '@chakra-ui/react';
import { FiEdit, FiTrash2 } from 'react-icons/fi';
import { FaDownload } from "react-icons/fa";
import { GetContractTypeOptionByValue, GetUserTypeOptionByValue } from '../../../components/options/GetOptionByValue';
import { decideAvailable } from '../../../components/options/DecideAvailable';
import { useNavigate } from 'react-router-dom';
import PdfExportModal from './modal/PdfExportModal';
import Pagination from '../../../components/common/Pagination';

export default function CardView({
  data,
  handleDelete,
  handleEdit,
  handleExport,
  selectedTemplate,
  setSelectedTemplate,
  isDownloading,
  paginationProps = null, // { currentPage, totalPages, onPageChange } 
}) {
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={6}>
        {data.map((user, i) => (
          <Box
            key={i}
            bg="whiteAlpha.700"
            backdropFilter="blur(12px)"
            border="1px solid"
            borderColor="orange.100"
            borderRadius="2xl"
            p={5}
            boxShadow="lg"
            transition="all 0.3s ease"
            _hover={{
              transform: 'scale(1.02)',
              boxShadow: 'xl',
            }}
          >
            {/* Header: Image and Name */}
            <Flex
              align="center"
              mb={4}
              cursor={'pointer'}
              gap={4}
              onClick={() => navigate(`/user/${user.id}/show`)}
            >
              <Avatar
                size="xl"
                name={user.name}
                src={`${process.env.REACT_APP_API_URL}/storage/${user.thumb}`}
                border="2px solid"
                borderColor="orange.400"
              />
              <Box>
                <Heading size="md">{user.name}</Heading>
                <Text fontSize="sm" color="gray.500">{user.name_kana}</Text>
                <Badge mt={1} colorScheme="orange">
                  {GetUserTypeOptionByValue(user.user_type)}
                </Badge>
              </Box>
            </Flex>

            {/* Meta Data */}
            <Box fontSize="md" color="gray.700">
              <Text><strong>支社:</strong> {user.branch}</Text>
              <Text><strong>部署:</strong> {user.department}</Text>
              <Text><strong>国:</strong> {user.country}</Text>
              <Text><strong>契約タイプ:</strong> {GetContractTypeOptionByValue(user.contract_type)}</Text>
              <Text><strong>参画可能日:</strong>{' '}
                <Text as="span" fontWeight="bold" color={decideAvailable(user.available_from)}>
                  {user.available_from}
                </Text>
              </Text>
              <Text fontSize="sm" mt={2} color="gray.600">
                技術スキル:
                {user.technologies && user.technologies.length > 0 ? (
                  <span style={{ fontWeight: 'bold', color: '#e67e22' }}>
                    {' '}
                    {user.technologies.map(t => t.technology).join(', ')}
                  </span>
                ) : (
                  ' なし'
                )}
              </Text>
              <Text mt={2}>
                {user.invite_count === 0 ? (
                  <Badge fontSize={"md"} colorScheme="yellow">未招待</Badge>
                ) : (
                  <Badge fontSize={"md"} colorScheme="gray">招待済み</Badge>
                )}
              </Text>
            </Box>

            {/* Actions */}
            <Flex justify="flex-end" gap={2} mt={4}>
              <Tooltip label="出力">
                <IconButton
                  size="sm"
                  icon={<FaDownload />}
                  colorScheme="orange"
                  variant="ghost"
                  // onClick={() => handleExport(user.id)}
                  onClick={onOpen}
                />
              </Tooltip>
              <PdfExportModal
                isOpen={isOpen}
                onClose={onClose}
                handleDownload={() => handleExport(user.id)}
                isDownloading={isDownloading}
                selectedTemplate={selectedTemplate}
                setSelectedTemplate={setSelectedTemplate}
              />
              <Tooltip label="編集">
                <IconButton
                  size="sm"
                  icon={<FiEdit />}
                  colorScheme="orange"
                  variant="ghost"
                  onClick={() => handleEdit(user.id)}
                />
              </Tooltip>
              <Tooltip label="削除">
                <IconButton
                  size="sm"
                  icon={<FiTrash2 />}
                  colorScheme="red"
                  variant="ghost"
                  onClick={() => handleDelete(user.id)}
                />
              </Tooltip>
            </Flex>
          </Box>
        ))}
      </SimpleGrid>
      {/* Optional Pagination */}
      {paginationProps && (
        <Flex justify="center" mt={8}>
          <Pagination
            currentPage={paginationProps.currentPage}
            totalPages={paginationProps.totalPages}
            onPageChange={paginationProps.onPageChange}
          />
        </Flex>
      )}
    </>
  );
}
